export const initialErrors = {
  email: ""
};
